import React from 'react'

const Navbar = () => {
    return (
        <div className='h-[90px] w-full  text-white flex justify-center'>
            <div className='flex w-[90%] justify-between items-center h-[90px]'>
                <div>
                    <div className="logo text-yellow-500 text-3xl font-bold">krishna</div>
                </div>
                <div className='flex'>
                    <ul className='hidden md:flex'>
                        <li className='mx-6 cursor-pointer'><a className='transition-all hover:text-[#08f8f0]' href="#about">About</a></li>
                        <li className='mx-6 cursor-pointer'><a className='transition-all hover:text-[#08f8f0]' href="#work">Work</a></li>
                        <li className='mx-6 cursor-pointer'><a className='transition-all hover:text-[#08f8f0]' href="#contact">Contact</a></li>
                    </ul>
                    <div className="social flex">
                        <a rel="noreferrer" className='mx-3 ml-4 cursor-pointer text-xl' target="_blank" href="https://twitter.com/Krishn_aGupta"><i className="bi bi-twitter"></i></a>
                        <a rel="noreferrer" className='mx-3 cursor-pointer text-xl' target="_blank" href="https://github.com/KrishnaGupt"><i className="bi bi-github"></i></a>
                        <a rel="noreferrer" className='mx-3 cursor-pointer text-xl' target="_blank" href="https://www.instagram.com/krishn_a1001"><i className="bi bi-instagram"></i></a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar
